import React, { Component } from "react";
import { connect } from "react-redux";
import Table from '@mawesi-sas/mws_react_component_table';

class Usuarios extends Component {
  render() {
    return (
      <Table
        reducer="tiposervicios"
        table={`modalCreateTipoProducto.data.tables.users`}
        columns={[
          {
            ID: 0,
            CAPTION: "",
            VALUE: "selected",
            TYPE: "selection",
            INPUT: "checkbox",
            WIDTH: 24,
            FIXED: true
          },
          {
            ID: 1,
            CAPTION: "Identificacion",
            VALUE: "username",
            TYPE: "text"
          },
          { ID: 2, CAPTION: "Nombre", VALUE: "name", TYPE: "text" },
          { ID: 3, CAPTION: "Area", VALUE: "area", TYPE: "text" }
        ]}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    modalCreateTipoProducto: state.tiposervicios.get("modalCreateTipoProducto")
  };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Usuarios);
